import { AdviserConfigurationInstruction } from "../../../Wrap/Models/Models/Adviser/Configuration/AdviserConfigurationInstruction";
import { Company } from "../../../Wrap/Models/Models/Company/Company";
import { AdviserConfiguration } from "../../../Wrap/Models/Models/Adviser/Configuration/AdviserConfiguration";
import { BaseStore } from "../../../react-core/Flux/BaseStore";
import { SharedDispatcher } from "./Variable";

export enum CustomActionType {
    Update = 0,
    Loading = 1,
    Success = 2,
    Error = 3,
    FlushStore = 4,
    UpdateWizardStep = 5,
    SubmitConfig = 6,
    GetCompany = 7,
    CancelConfig = 8,
}

export interface SharedStoreStaticState {
    isLoading?: boolean;
    actionType: CustomActionType;
    data?: AdviserConfigurationInstruction;
    wizardStep?: number;
    company?: Company;
    submitResponse?: AdviserConfiguration;
}

export class SharedStoreStatic extends BaseStore<SharedStoreStaticState> {
    constructor() {
        super();
        this.subscribeToDispatcher(SharedDispatcher, (actionData) => this.onSharedStoreResponse(actionData));
    }

    public getLastResult(): SharedStoreStaticState {
        return this.getState();
    }

    public isLoading(): boolean {
        return this.getState().isLoading;
    }

    public getData() {
        return this.getState().data;
    }

    public getSubmitResponse(): AdviserConfiguration {
        return this.getState().submitResponse;
    }

    public getActionType() {
        return this.getState().actionType;
    }

    public getWizardStep() {
        return this.getState().wizardStep;
    }

    public getCompany(): Company {
        return this.getState().company;
    }

    protected getDefaultState(): SharedStoreStaticState {
        return {
            actionType: CustomActionType.Loading,
            data: null,
            wizardStep: 1,
            submitResponse: null,
            company: null,
        };
    }

    private onSharedStoreResponse(actionData): void {
        switch (actionData.actionType) {
            case CustomActionType.Success:
                this.setState({ actionType: CustomActionType.Success, data: actionData.payload });
                break;
            case CustomActionType.Error:
                this.setState({ actionType: CustomActionType.Error });
                break;
            case CustomActionType.Loading:
                this.setState({ isLoading: true, actionType: CustomActionType.Loading });
                break;
            case CustomActionType.UpdateWizardStep:
                this.setState({ wizardStep: actionData.payload, actionType: actionData.actionType });
                break;
            case CustomActionType.SubmitConfig:
                this.setState({ submitResponse: actionData.payload, actionType: actionData.actionType });
                break;
            case CustomActionType.GetCompany:
                this.setState({ company: actionData.payload, actionType: actionData.actionType });
                break;
        }
    }
}
